// Utility function to normalize API responses dynamically
export const GetOldResponse = (newResponse , isHavingObject = false) => {
    if (!newResponse || !newResponse.data) {
      throw new Error("Invalid response structure");
    }
  
    // Get the main key dynamically (e.g., `getBuckets` or others)
    const [mainKey] = Object.keys(newResponse.data);
    const dataArray = newResponse.data[mainKey];
  
    if (!Array.isArray(dataArray)) {
      throw new Error("Expected an array in the response");
    }
  
    // Transform each item dynamically
    // const transformedData = dataArray.map((item) => {
    //   const transformedItem = {};
  
    //   // Automatically copy all fields to the new object, converting keys to uppercase
    //   Object.keys(item).forEach((key) => {
    //     transformedItem[key.toUpperCase()] = item[key] ? item[key] : null; // Default to null if value is undefined
    //   });
  
    //   return transformedItem;
    // });
    const transformedData = dataArray.map((item) => {
      // Check if the item is an array
      if (isHavingObject) {
    // Transform each sub-item within the object of objects
    const transformedObject = {};
    Object.keys(item).forEach((subKey) => {
      const subItem = item[subKey];
      const transformedSubItem = {};

      // Transform each field in the sub-item
      Object.keys(subItem).forEach((key) => {
        transformedSubItem[key.toUpperCase()] = subItem[key] !== undefined ? subItem[key] : null;
      });

      // Add the transformed sub-item to the new object with the same key
      transformedObject[subKey] = transformedSubItem;
    });

    return transformedObject;
      } else {
        // Handle the case where item is an object
        const transformedItem = {};
        Object.keys(item).forEach((key) => {
          transformedItem[key.toUpperCase()] = item[key] !== undefined ? item[key] : null;
        });
        return transformedItem;
      }
    });
    
  
    // Return the transformed response in the old format
    return {
      responses: [
        {
          id: null,
          success: true,
          data: transformedData,
          format: "json",
          version: "1",
          code: 200,
          message: "OK",
        },
      ],
      success: true
    };
  };


  // export const mapToOldResponse = (newResponse) => {
  //   if (!Array.isArray(newResponse)) {
  //     throw new Error("The new response must be an array.");
  //   }
  
  //   // Recursively transform keys to uppercase for nested objects/arrays
  //   const transformKeysToUppercase = (data) => {
  //     if (Array.isArray(data)) {
  //       return data.map(transformKeysToUppercase); // Recursively transform array elements
  //     }
  
  //     if (data && typeof data === "object") {
  //       const transformed = {};
  //       Object.keys(data).forEach((key) => {
  //         transformed[key.toUpperCase()] = transformKeysToUppercase(data[key]); // Convert keys to uppercase recursively
  //       });
  //       return transformed;
  //     }
  
  //     return data; // Return value directly if not an object or array
  //   };
  
  //   // Extract and normalize the `data` field, removing unwanted keys
  //   const extractAndFlattenData = (data) => {
  //     if (typeof data !== "object" || data === null) return []; // Ensure data is an object
  //     if (Array.isArray(data)) return data.map(transformKeysToUppercase); // Transform array data
  
  //     // Flatten keys like agentCommissionProcured or getTeamMember directly
  //     const topLevelKeys = Object.keys(data);
  //     if (topLevelKeys.length === 1 && Array.isArray(data[topLevelKeys[0]])) {
  //       return data[topLevelKeys[0]].map(transformKeysToUppercase);
  //     }
  
  //     return [transformKeysToUppercase(data)];
  //   };
  
  //   // Process each item in the new response array
  //   const transformedResponses = newResponse.map((response) => {
  //     if (response.data) {
  //       const flattenedData = extractAndFlattenData(response.data);
  
  //       return {
  //         id: null,
  //         success: true,
  //         data: flattenedData,
  //         encoding: false,
  //         code: 200,
  //         errorCode: null,
  //         message: "OK",
  //         count: flattenedData.length,
  //         countIsEstimate: false,
  //         errors: [],
  //         time: 0.005, // Example fixed time; adjust if needed
  //       };
  //     }
  
  //     return null; // Skip invalid response entries
  //   });
  
  //   // Wrap the results into the old format
  //   return {
  //     id: 1,
  //     success: true,
  //     responses: transformedResponses.filter(Boolean), // Remove null responses
  //     format: "json",
  //     version: "1",
  //     code: 200,
  //     message: "OK",
  //   };
  // };
  
  //below is the common code for Promise 

  export const mapToOldResponse = (newResponse) => {
    if (!Array.isArray(newResponse)) {
      throw new Error("The new response must be an array.");
    }
  
    // Recursively transform keys to uppercase for nested objects/arrays
    const transformKeysToUppercase = (data) => {
      if (Array.isArray(data)) {
        return data.map(transformKeysToUppercase); // Recursively transform array elements
      }
  
      if (data && typeof data === "object") {
        const transformed = {};
        Object.keys(data).forEach((key) => {
          transformed[key.toUpperCase()] = transformKeysToUppercase(data[key]); // Convert keys to uppercase recursively
        });
        return transformed;
      }
  
      return data; // Return value directly if not an object or array
    };
  
    // Process each item in the new response array
    const transformedResponses = newResponse.map((response) => {
      // Handle dynamic transformation for the top-level `data` key
      if (response.data) {
        const transformedData = transformKeysToUppercase(response.data);
  
        return {
          id: null,
          success: true,
          data: Array.isArray(transformedData)
            ? transformedData // If data is an array, use as-is
            : [transformedData], // Wrap single objects in an array
          encoding: false,
          code: 200,
          errorCode: null,
          message: "OK",
          count: Array.isArray(transformedData) ? transformedData.length : 1,
          countIsEstimate: false,
          errors: [],
          time: 0.005, // Example fixed time; adjust if needed
        };
      }
  
      return null; // Skip invalid response entries
    });
  
    // Wrap the results into the old format
    return {
      id: 1,
      success: true,
      responses: transformedResponses.filter(Boolean), // Remove null responses
      format: "json",
      version: "1",
      code: 200,
      message: "OK",
    };
  };
  
  